import JarvisBaseSettingsService from "Jarvis/JarvisServices/JarvisBaseSettingsService";
export const getGraphQLUrl = () => {
  return JarvisBaseSettingsService.getApiEndPoint("Jarvis") + "graphql";
};
